import { render } from "./IframeViewer.vue?vue&type=template&id=6d372f8e&scoped=true"
import script from "./IframeViewer.vue?vue&type=script&lang=js"
export * from "./IframeViewer.vue?vue&type=script&lang=js"

import "./IframeViewer.vue?vue&type=style&index=0&id=6d372f8e&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d372f8e"]])

export default __exports__